import React, { useState } from "react";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false); 
  const [error, setError] = useState(null); 
  const [success, setSuccess] = useState(null); 

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true); 

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      setIsLoading(false);
      setError("Please enter a valid email address.");
      return;
    }

    setError(null);
    setSuccess(null);

    try {
      // Example API call to submit the email (you can replace this with your actual API)
      // For demonstration purposes, we're simulating an API call with a timeout
      const response = await new Promise((resolve, reject) => {
        setTimeout(() => {
          // Simulate a successful submission (you can replace this with actual API logic)
          resolve({ success: true });
        }, 2000);
      });

      if (response.success) {
        setSuccess("Thank you for subscribing!");
      } else {
        setError("Oops! Something went wrong. Please try again.");
      }
    } catch (error) {
      setError("Oops! Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="max-w-5xl bg-white rounded-2xl mx-auto px-4 md:px-8 py-8 pb-12">
      <div className="text-center">
        <h2 className="mb-2 text-textNeutral font-bold">Newsletter</h2>
        <p className="text-xl lg:text-2xl font-bold mb-4 text-textPrimary">
          Let's stay in touch
        </p>
        <form
          className="flex flex-col justify-center gap-3 items-center"
          // onSubmit={handleSubmit}
          action="https://submit-form.com/sCRcDz7LX"
        >
          <label for="email">Email</label>
          <input
            required
            type="email"
            name="email"
            placeholder="E-mail"
            className="min-w-full md:min-w-96 p-2.5 px-4 rounded-3xl border border-boderLight placeholder:text-boderLight text-textPrimary outline-none poppins"
            value={email}
            onChange={handleEmailChange}
          />
          <input
            type="hidden"
            name="_redirect"
            value="https://www.lumor.studio/"
          />

          <button
            type="submit"
            className="border border-primary md:min-w-96 font-bold justify-center bg-white hover:bg-opacity-80 flex items-center gap-2 text-lg text-white p-2 px-4 rounded-3xl hover:bg-primary-dark transition duration-200"
            disabled={isLoading}
          >
            <div>
              <svg
                className="text-primary"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.2448 0.57632C19.2868 0.212244 20.2878 1.2132 19.9237 2.25518L13.8471 19.618C13.4522 20.7441 11.8831 20.8077 11.399 19.7175L8.46685 13.1211L12.5938 8.99316C12.7297 8.84735 12.8036 8.65449 12.8001 8.45522C12.7966 8.25595 12.7159 8.06583 12.575 7.9249C12.434 7.78398 12.2439 7.70325 12.0446 7.69974C11.8454 7.69622 11.6525 7.77019 11.5067 7.90605L7.3787 12.0329L0.782123 9.10084C-0.308075 8.61575 -0.243464 7.04765 0.881605 6.65281L18.2448 0.57632Z"
                />
              </svg>
            </div>
            <p className="text-primary">
              {isLoading ? "Subscribing..." : "Subscribe"}
            </p>
            
          </button>

          {/* Error message */}
          {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

          {/* Success message */}
          {success && <p className="text-green-500 text-sm mt-2">{success}</p>}
        </form>
      </div>
    </div>
  );
};

export default Newsletter;
